export const entries = [
	{
		'title': 'Todos',
		'singular': 'Todo',
		'type': 'repository',
		'parentId': null,
		'rank': 1,
		'id': 'aB-zKTDZjDINyCLqhgdMK',
		'fakeId': 'aB-zKTDZjDINyCLqhgdMK',
		'color': '#FFD93D',
		'isBookmarked': true
	},
	{
		'title': 'Daily journal',
		'singular': 'Journal entry',
		'type': 'repository',
		'parentId': null,
		'rank': 2,
		'id': '9hhm_4uVcAH6Ee4MTdOPi',
		'fakeId': '9hhm_4uVcAH6Ee4MTdOPi',
		'color': '#6BCB77',
		'isBookmarked': true
	},
	{
		'label': 'Main goal',
		'slug': 'main-goal',
		'required': true,
		'type': 'templatePropertyString',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'rank': 1,
		'id': 'YT42ZJemo8LSquUx9toQH',
		'fakeId': 'YT42ZJemo8LSquUx9toQH'
	},
	{
		'label': 'Do',
		'slug': 'do',
		'required': true,
		'type': 'templatePropertyString',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 0,
		'id': '-CPX86SrlnffwRzvpNgOq',
		'fakeId': '-CPX86SrlnffwRzvpNgOq'
	},
	{
		'label': 'Done',
		'slug': 'done',
		'type': 'templatePropertyBoolean',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 2,
		'id': 'r7ANdRhfe8OXcWUVGMPxi',
		'fakeId': 'r7ANdRhfe8OXcWUVGMPxi'
	},
	{
		'label': 'Todos',
		'slug': 'todos',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'required': false,
		'allowMany': true,
		'type': 'templatePropertyBelongsTo',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'rank': 2,
		'id': '1Q3cl3JpX7S2i8Dj_F4Dv',
		'fakeId': '1Q3cl3JpX7S2i8Dj_F4Dv'
	},
	{
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'type': 'templatePropertyText',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 1,
		'id': 'o4CCkZCyPKLehgYeVEkVJ',
		'fakeId': 'o4CCkZCyPKLehgYeVEkVJ'
	},
	{
		'type': 'note',
		'title': 'These two collections (at the top-left) are here to help you do that',
		'parentId': null,
		'rank': 3,
		'id': 'q0rn1wsW4tz0f8y-n5cen',
		'fakeId': 'q0rn1wsW4tz0f8y-n5cen',
		'xy': {
			'x': 18.392717247652968,
			'y': 80.84882722665046
		}
	},
	{
		'type': 'note',
		'title': 'Journaling your goals daily can be quite an impactful habit 🌱',
		'parentId': null,
		'rank': 7,
		'id': '5YFy6ogmE3Hzeb_768W77',
		'fakeId': '5YFy6ogmE3Hzeb_768W77',
		'xy': {
			'x': -16.448514827776563,
			'y': -35.51854671274543
		}
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Day',
		'slug': 'day',
		'required': true,
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'rank': 0,
		'id': 'eeip_4xFDMUq-L5GN9jp9',
		'fakeId': 'eeip_4xFDMUq-L5GN9jp9'
	},
	{
		'type': 'note',
		'title': 'This is your planning view — you can keep notes here. Because not all data needs to be organized, just somewhere you can find it. 🤗',
		'parentId': null,
		'rank': 8,
		'xy': {
			'x': 412,
			'y': -104
		},
		'id': 'Nat8Xe0iiYq3AQvyZs0Rz',
		'fakeId': 'Nat8Xe0iiYq3AQvyZs0Rz'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'TA_B6hNg7trKIn6oRgqMk',
		'fakeId': 'TA_B6hNg7trKIn6oRgqMk',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'TA_B6hNg7trKIn6oRgqMk',
		'value': 'Water the plants',
		'id': '4oKwT0WOyzJ1UR3scUi9F',
		'fakeId': '4oKwT0WOyzJ1UR3scUi9F'
	},
	{
		'type': 'entryPropertyBoolean',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'r7ANdRhfe8OXcWUVGMPxi',
		'slug': 'done',
		'parentId': 'TA_B6hNg7trKIn6oRgqMk',
		'value': false,
		'id': 'OqqM9cs8owpDPv42SRX0g',
		'fakeId': 'OqqM9cs8owpDPv42SRX0g'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'id': 'rQBbD8zGPvhVtiTFUwUG6',
		'fakeId': 'rQBbD8zGPvhVtiTFUwUG6',
		'rank': 'a0',
		'isArchived': false
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'eeip_4xFDMUq-L5GN9jp9',
		'slug': 'day',
		'parentId': 'rQBbD8zGPvhVtiTFUwUG6',
		'value': '2026-05-17',
		'id': 'XM6GqWNGHjpH9cqyQGBRJ',
		'fakeId': 'XM6GqWNGHjpH9cqyQGBRJ'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'YT42ZJemo8LSquUx9toQH',
		'slug': 'main-goal',
		'parentId': 'rQBbD8zGPvhVtiTFUwUG6',
		'value': 'Improve my workflow',
		'id': 'iDMqaVodSDfWfEt-CBf2a',
		'fakeId': 'iDMqaVodSDfWfEt-CBf2a'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': '6YEfTmq1ZDA0FdyhTMwNN',
		'fakeId': '6YEfTmq1ZDA0FdyhTMwNN',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': '6YEfTmq1ZDA0FdyhTMwNN',
		'value': 'Organize my priorities using Untwyn',
		'id': 'Lbn_vLJgR276niof8KLxb',
		'fakeId': 'Lbn_vLJgR276niof8KLxb'
	},
	{
		'type': 'entryPropertyBoolean',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'r7ANdRhfe8OXcWUVGMPxi',
		'slug': 'done',
		'parentId': '6YEfTmq1ZDA0FdyhTMwNN',
		'value': false,
		'id': '1MDICLPlvXbY-HVn6Oa8B',
		'fakeId': '1MDICLPlvXbY-HVn6Oa8B'
	},
	{
		'parentId': 'rQBbD8zGPvhVtiTFUwUG6',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '1Q3cl3JpX7S2i8Dj_F4Dv',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'todos',
		'value': '6YEfTmq1ZDA0FdyhTMwNN',
		'id': 'D-4eOE5g6RQPsX-iaUfrs',
		'fakeId': 'D-4eOE5g6RQPsX-iaUfrs'
	},
	{
		'parentId': 'rQBbD8zGPvhVtiTFUwUG6',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '1Q3cl3JpX7S2i8Dj_F4Dv',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'todos',
		'value': 'TA_B6hNg7trKIn6oRgqMk',
		'id': 'JDkQfDDBCsrJFMzR2vX4O',
		'fakeId': 'JDkQfDDBCsrJFMzR2vX4O'
	},
	{
		'type': 'note',
		'title': 'Welcome notes',
		'variant': 'header',
		'parentId': null,
		'rank': 9,
		'xy': {
			'x': 94.84787955540448,
			'y': -147.30200984910667
		},
		'id': '4CtpN_crSPYaUn39JwX86',
		'fakeId': '4CtpN_crSPYaUn39JwX86'
	},
	{
		'type': 'templatePropertyHas',
		'label': 'Journaled on',
		'slug': 'journaled-on',
		'targetRepositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'targetPropertySlug': 'todos',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 1,
		'id': 'MkAgGeSXCOcF5CYZDRlP3',
		'fakeId': 'MkAgGeSXCOcF5CYZDRlP3'
	}
];